import { useEffect, useState } from "react";
import * as api from "../api";

export const usePatientDashboard = (
  fetchPatients,
  onSelectPatient,
  patientsData
) => {
  const [newPatient, setNewPatient] = useState({
    name: "",
    age: "",
    gender: "Other",
    diagnosis: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [displayLimit, setDisplayLimit] = useState(15);

  // Search and filter patients
  useEffect(() => {
    if (!patientsData) return;

    // Filter patients based on search query
    const filtered = patientsData.filter((patient) => {
      if (!searchQuery.trim()) return true;

      const query = searchQuery.toLowerCase();
      return (
        patient.name.toLowerCase().includes(query) ||
        patient.diagnosis?.toLowerCase().includes(query) ||
        patient.id.toString().includes(query) ||
        patient.age.toString().includes(query)
      );
    });

    setFilteredPatients(filtered);
    setHasMore(filtered.length > displayLimit);
  }, [searchQuery, patientsData, displayLimit]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset to first page on new search
  };

  const loadMore = () => {
    setDisplayLimit((prevLimit) => prevLimit + 10);
    setPage((prevPage) => prevPage + 1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPatient((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      const patientToCreate = {
        ...newPatient,
        age: parseInt(newPatient.age, 10),
      };

      if (isNaN(patientToCreate.age)) {
        throw new Error("Age must be a valid number.");
      }

      await api.createPatient(patientToCreate);
      setNewPatient({ name: "", age: "", gender: "Other", diagnosis: "" });
      fetchPatients();
      setShowForm(false);
    } catch (err) {
      console.error("Error creating patient:", err);
      setError(err.response?.data?.detail || err.message);
    }
    setIsLoading(false);
  };

  return {
    newPatient,
    isLoading,
    error,
    showForm,
    setShowForm,
    searchQuery,
    setSearchQuery,
    handleSearchChange,
    filteredPatients,
    page,
    hasMore,
    loadMore,
    displayedPatients: filteredPatients.slice(0, displayLimit),
    handleInputChange,
    handleSubmit,
  };
};
